module.exports = __webpack_public_path__ + "static/media/BX.a397a075.svg";